export const ACTIVITY_VIEW_TYPES = {
  ALL: "all",
  ARCHIVED: "archived",
};

export const GENERAL_FILTER_TYPES = {
  ALL: "all",
};

export const ACTIVITY_MESSAGE_TYPES = {
  CHAT: "CHAT",
  SMS: "SMS",
  AGENT_VM: "AGENT+VM",
};

export const ACTIVITY_OPERATIONS = {
  UNREAD: "UNREAD",
  READ: "READ",
  FLAG: "FLAG",
  UNFLAG: "UNFLAG",
  ARCHIVE: "ARCHIVE",
  UNARCHIVE: "UNARCHIVE",
};

export const CHAT_ACTIVITY_TYPES = {
  LEAD: "Lead",
  SPAM: "Spam",
  NON_A_SUPPORT: "Non-Actionable Support",
  A_SUPPORT: "Actionable Support",
  RECRUITMENT: "Recruitment",
  TESTING: "Testing",
  PROCHATS_USE: "ProChats Use",
};

export const ACTIVITY_PAGES = {
  ACTIVITY: "ACTIVITY",
  CHAT_ACTIVITY: "CHAT_ACTIVITY",
};
